import React from 'react';
import { Divider, Spin } from 'antd';

import { PlusCircleIcon } from '@/assets/icons/icons';
import SearchInput from './SearchInput';

import './ProductSelectDropdownPanel.scss';

interface ProductSelectDropdownPanelProps {
  menu: React.ReactNode;
  onSearchChange: (value: string) => void;
  onSearchClear: () => void;
  loading?: boolean;
  searchInputKey?: number;
  onOpenAddProduct?: () => void;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
  showAddNew?: boolean;
  isEmptyResults?: boolean;
}

const ProductSelectDropdownPanel: React.FC<ProductSelectDropdownPanelProps> = ({
  menu,
  onSearchChange,
  onSearchClear,
  loading = false,
  searchInputKey = 0,
  onOpenAddProduct,
  onScroll,
  showAddNew = true,
  isEmptyResults = false,
}) => {
  return (
    <>
      <div className='form-dropdown-input'>
        <SearchInput
          key={`product-search-${searchInputKey}`}
          placeholder='Search product'
          width='100%'
          onChange={onSearchChange}
          onClear={onSearchClear}
        />
      </div>

      <div style={{ maxHeight: 256, overflow: 'auto' }} onScroll={onScroll}>
        {menu}
        {!loading && isEmptyResults && (
          <div className='product-dropdown-empty'>No products found</div>
        )}
      </div>

      {loading && (
        <div
          style={{
            padding: 8,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Spin size='small' />
        </div>
      )}

      {showAddNew && onOpenAddProduct && (
        <>
          <Divider style={{ margin: '8px 0' }} />
          <div
            className='add-product-btn'
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={() => onOpenAddProduct()}
          >
            <PlusCircleIcon />
            <span className='add-product-text'>Add new product</span>
          </div>
        </>
      )}
    </>
  );
};

export default ProductSelectDropdownPanel;
